export default {
    navigationBarTitleText: '楼盘详情',
  };
  